import { createServerFn } from '@tanstack/react-start';
import { z } from 'zod';
import { PortalOrdersBoard } from '@api/BoardSDK';
import { withBoardAuth } from '@generated/server/boardAuth.server';

const GEORGE_ID = '106410322';

/** Records a reader donation on the Portal Orders board and pings George; payment happens next via Zelle / PayPal / card. */
export const recordDonation = createServerFn({ method: 'POST' })
  .validator(z.object({
    amount: z.number().min(1).max(100000),
    method: z.enum(['Zelle', 'Venmo', 'PayPal', 'Credit Card']),
    name: z.string().trim().max(120).optional(),
    email: z.string().trim().max(200).optional(),
    note: z.string().trim().max(1000).optional(),
    anonymous: z.boolean(),
  }))
  .handler(async ({ data }) => {
    const who = data.anonymous ? 'Anonymous' : data.name || 'Reader';
    const board = new PortalOrdersBoard();
    const item = await withBoardAuth(() => board.item().create({
      name: `Donation: ${who}`,
      status: 'New Order',
      orderDate: new Date(),
      totalContractValue: data.amount,
      paymentMethod: data.method,
      contactPerson: data.anonymous ? 'Anonymous (name not for publication)' : data.name || null,
      email: data.email ? { email: data.email, label: data.email } : null,
      publication: 'Donation',
      specialInstructions: data.note || null,
    }).execute());
    try {
      await withBoardAuth(() => board.item(item.id).notify(GEORGE_ID).create(`New donation pledge: $${data.amount} by ${data.method} from ${who}${data.note ? `: "${data.note.slice(0, 120)}"` : ''}`).execute());
    } catch (e) { console.error('[donate] notify failed', e); }
    return { id: item.id };
  });
